import { useState, useEffect, useCallback } from "react";
import config from '../config';

// Tema konfigürasyonu - Tüm renk ayarları tek yerde
const THEME_CONFIG = {
  general: {
    backgroundColor: {
      key: "appBackgroundColor",
      cssVar: "--app-background-color",
      default: "#060b10",
      label: "Arka Plan Rengi",
    },
  },
  header: {
    titleColor: {
      key: "headerTitleColor",
      cssVar: "--header-title-color",
      default: "#ffffff",
      label: "Başlık Rengi",
    },
    subtitleColor: {
      key: "headerSubtitleColor",
      cssVar: "--header-subtitle-color",
      default: "#e0e0e0",
      label: "Alt Başlık Rengi",
    },
    iconColor: {
      key: "headerIconColor",
      cssVar: "--header-icon-color",
      default: "#ffffff",
      label: "İkon Rengi",
    },
    iconBgColor: {
      key: "headerIconBgColor",
      cssVar: "--header-icon-bg-color",
      default: "rgba(255, 255, 255, 0.1)",
      label: "İkon Arka Plan Rengi",
    },
  },
  mainCategory: {
    bgColor: {
      key: "mainCategoryBgColor",
      cssVar: "--main-category-bg-color",
      default: "#0E212E",
      label: "Arka Plan Rengi",
    },
    textColor: {
      key: "mainCategoryTextColor",
      cssVar: "--main-category-text-color",
      default: "#FFFFFF",
      label: "Yazı Rengi",
    },
    iconColor: {
      key: "mainCategoryIconColor",
      cssVar: "--main-category-icon-color",
      default: "#FFFFFF",
      label: "İkon Rengi",
    },
    activeBgColor: {
      key: "mainCategoryActiveBgColor",
      cssVar: "--main-category-active-bg-color",
      default: "#1375E1",
      label: "Aktif Arka Plan Rengi",
    },
    activeGlowColor: {
      key: "mainCategoryActiveGlowColor",
      cssVar: "--main-category-active-glow-color",
      default: "rgba(19, 117, 225, 0.3)",
      label: "Aktif Parıltı Rengi",
    },
  },
  tab: {
    bgColor: {
      key: "tabBgColor",
      cssVar: "--tab-bg-color",
      default: "#335166",
      label: "Arka Plan Rengi",
    },
    textColor: {
      key: "tabTextColor",
      cssVar: "--tab-text-color",
      default: "#FFFFFF",
      label: "Yazı Rengi",
    },
    iconColor: {
      key: "tabIconColor",
      cssVar: "--tab-icon-color",
      default: "#FFFFFF",
      label: "İkon Rengi",
    },
    activeBgColor: {
      key: "tabActiveBgColor",
      cssVar: "--tab-active-bg-color",
      default: "#1375E1",
      label: "Aktif Arka Plan Rengi",
    },
    activeGlowColor: {
      key: "tabActiveGlowColor",
      cssVar: "--tab-active-glow-color",
      default: "rgba(19, 117, 225, 0.3)",
      label: "Aktif Parıltı Rengi",
    },
  },
  bonusButtons: {
    requestBgColor: {
      key: "bonusRequestBgColor",
      cssVar: "--bonus-request-bg-color",
      default: "#1375E1",
      label: "Talep Et - Arka Plan Rengi",
    },
    requestTextColor: {
      key: "bonusRequestTextColor",
      cssVar: "--bonus-request-text-color",
      default: "#FFFFFF",
      label: "Talep Et - Yazı Rengi",
    },
    requestHoverBgColor: {
      key: "bonusRequestHoverBgColor",
      cssVar: "--bonus-request-hover-bg-color",
      default: "#0F5FC4",
      label: "Talep Et - Hover Arka Plan",
    },
    requestGlowColor: {
      key: "bonusRequestGlowColor",
      cssVar: "--bonus-request-glow-color",
      default: "rgba(20, 117, 225, 0.4)",
      label: "Talep Et - Parıltı Rengi",
    },
    requestHoverGlowColor: {
      key: "bonusRequestHoverGlowColor",
      cssVar: "--bonus-request-hover-glow-color",
      default: "rgba(20, 117, 225, 0.5)",
      label: "Talep Et - Hover Parıltı",
    },
    rulesBgColor: {
      key: "bonusRulesBgColor",
      cssVar: "--bonus-rules-bg-color",
      default: "rgba(255, 255, 255, 0.2)",
      label: "Kurallar - Arka Plan Rengi",
    },
    rulesTextColor: {
      key: "bonusRulesTextColor",
      cssVar: "--bonus-rules-text-color",
      default: "#FFFFFF",
      label: "Kurallar - Yazı Rengi",
    },
    rulesHoverBgColor: {
      key: "bonusRulesHoverBgColor",
      cssVar: "--bonus-rules-hover-bg-color",
      default: "rgba(255, 255, 255, 0.3)",
      label: "Kurallar - Hover Arka Plan",
    },
    rulesGlowColor: {
      key: "bonusRulesGlowColor",
      cssVar: "--bonus-rules-glow-color",
      default: "rgba(44, 73, 92, 0.4)",
      label: "Kurallar - Parıltı Rengi",
    },
    rulesHoverGlowColor: {
      key: "bonusRulesHoverGlowColor",
      cssVar: "--bonus-rules-hover-glow-color",
      default: "rgba(44, 73, 92, 0.5)",
      label: "Kurallar - Hover Parıltı",
    },
  },
  rulesPopup: {
    backgroundColor: {
      key: "rulesPopupBgColor",
      cssVar: "--rules-popup-bg-color",
      default: "#1A2C38",
      label: "Popup Arka Plan Rengi",
    },
    headerTitleColor: {
      key: "rulesPopupHeaderTitleColor",
      cssVar: "--rules-popup-header-title-color",
      default: "#FFFFFF",
      label: "Başlık Rengi",
    },
    subtitleColor: {
      key: "rulesPopupSubtitleColor",
      cssVar: "--rules-popup-subtitle-color",
      default: "rgba(255, 255, 255, 0.8)",
      label: "Kurallar ve Koşullar Yazısı",
    },
    closeIconColor: {
      key: "rulesPopupCloseIconColor",
      cssVar: "--rules-popup-close-icon-color",
      default: "white",
      label: "Çarpı İkonu Rengi",
    },
    closeIconBgColor: {
      key: "rulesPopupCloseIconBgColor",
      cssVar: "--rules-popup-close-icon-bg-color",
      default: "rgba(255, 255, 255, 0.2)",
      label: "Çarpı İkonu Arka Plan",
    },
    ruleContentBgColor: {
      key: "rulesPopupRuleContentBgColor",
      cssVar: "--rules-popup-rule-content-bg-color",
      default: "rgba(15, 33, 46, 0.6)",
      label: "Kural İçerik Arka Plan",
    },
    ruleTitleColor: {
      key: "rulesPopupRuleTitleColor",
      cssVar: "--rules-popup-rule-title-color",
      default: "rgba(255, 255, 255, 0.9)",
      label: "Kural Başlık Rengi",
    },
    ruleTextColor: {
      key: "rulesPopupRuleTextColor",
      cssVar: "--rules-popup-rule-text-color",
      default: "rgba(255, 255, 255, 0.7)",
      label: "Kural Metin Rengi",
    },
    ruleNumberBgColor: {
      key: "rulesPopupRuleNumberBgColor",
      cssVar: "--rules-popup-rule-number-bg-color",
      default: "#1375E1",
      label: "Kural Numarası Arka Plan",
    },
    ruleNumberTextColor: {
      key: "rulesPopupRuleNumberTextColor",
      cssVar: "--rules-popup-rule-number-text-color",
      default: "#FFFFFF",
      label: "Kural Numarası Yazı Rengi",
    },
    ruleContentHoverBgColor: {
      key: "rulesPopupRuleContentHoverBgColor",
      cssVar: "--rules-popup-rule-content-hover-bg-color",
      default: "rgba(20, 40, 55, 0.6)",
      label: "Kural İçerik Hover Arka Plan",
    },
    footerBgColor: {
      key: "rulesPopupFooterBgColor",
      cssVar: "--rules-popup-footer-bg-color",
      default: "rgba(15, 33, 46, 0.5)",
      label: "Footer Arka Plan Rengi",
    },
    closeButtonBgColor: {
      key: "rulesPopupCloseButtonBgColor",
      cssVar: "--rules-popup-close-button-bg-color",
      default: "rgba(20, 117, 225, 0.9)",
      label: "Anladım Butonu Arka Plan",
    },
    closeButtonTextColor: {
      key: "rulesPopupCloseButtonTextColor",
      cssVar: "--rules-popup-close-button-text-color",
      default: "#FFFFFF",
      label: "Anladım Butonu Yazı Rengi",
    },
    closeButtonHoverBgColor: {
      key: "rulesPopupCloseButtonHoverBgColor",
      cssVar: "--rules-popup-close-button-hover-bg-color",
      default: "rgba(20, 117, 225, 1)",
      label: "Anladım Butonu Hover Arka Plan",
    },
  },
  historyPopup: {
    backgroundColor: {
      key: "historyPopupBgColor",
      cssVar: "--history-popup-bg-color",
      default: "#1A2C38",
      label: "Popup Arka Plan Rengi",
    },
    headerTitleColor: {
      key: "historyPopupHeaderTitleColor",
      cssVar: "--history-popup-header-title-color",
      default: "#FFFFFF",
      label: "Başlık Rengi (Talep Geçmişi)",
    },
    closeIconColor: {
      key: "historyPopupCloseIconColor",
      cssVar: "--history-popup-close-icon-color",
      default: "#FFFFFF",
      label: "Çarpı İkonu Rengi",
    },
    closeIconBgColor: {
      key: "historyPopupCloseIconBgColor",
      cssVar: "--history-popup-close-icon-bg-color",
      default: "#0F212E",
      label: "Çarpı İkonu Arka Plan",
    },
    itemBgColor: {
      key: "historyPopupItemBgColor",
      cssVar: "--history-popup-item-bg-color",
      default: "#0F212E",
      label: "Geçmiş Öğesi Arka Plan",
    },
    itemBorderColor: {
      key: "historyPopupItemBorderColor",
      cssVar: "--history-popup-item-border-color",
      default: "#2C495C",
      label: "Geçmiş Öğesi Kenarlık",
    },
    dateBgColor: {
      key: "historyPopupDateBgColor",
      cssVar: "--history-popup-date-bg-color",
      default: "transparent",
      label: "Tarih Bölümü Arka Plan",
    },
    dateTextColor: {
      key: "historyPopupDateTextColor",
      cssVar: "--history-popup-date-text-color",
      default: "#FFFFFF",
      label: "Tarih Yazı Rengi",
    },
    contentTitleColor: {
      key: "historyPopupContentTitleColor",
      cssVar: "--history-popup-content-title-color",
      default: "#FFFFFF",
      label: "İçerik Başlık Rengi",
    },
    successMessageColor: {
      key: "historyPopupSuccessMessageColor",
      cssVar: "--history-popup-success-message-color",
      default: "#4CAF50",
      label: "Başarılı Mesaj Rengi",
    },
    errorMessageColor: {
      key: "historyPopupErrorMessageColor",
      cssVar: "--history-popup-error-message-color",
      default: "#F44336",
      label: "Hata Mesaj Rengi",
    },
    loadingTextColor: {
      key: "historyPopupLoadingTextColor",
      cssVar: "--history-popup-loading-text-color",
      default: "#FFFFFF",
      label: "Yükleniyor Yazı Rengi",
    },
    emptyTextColor: {
      key: "historyPopupEmptyTextColor",
      cssVar: "--history-popup-empty-text-color",
      default: "rgba(255, 255, 255, 0.7)",
      label: "Boş Durum Yazı Rengi",
    },
  },
  multipleBonusDialog: {
    backgroundColor: {
      key: "multipleBonusDialogBgColor",
      cssVar: "--multiple-bonus-dialog-bg-color",
      default: "#1A2C38",
      label: "Dialog Arka Plan Rengi",
    },
    headerTitleColor: {
      key: "multipleBonusDialogHeaderTitleColor",
      cssVar: "--multiple-bonus-dialog-header-title-color",
      default: "#FFFFFF",
      label: "Başlık Rengi (Lütfen Bonus Seç)",
    },
    headerSubtitleColor: {
      key: "multipleBonusDialogHeaderSubtitleColor",
      cssVar: "--multiple-bonus-dialog-header-subtitle-color",
      default: "rgba(255, 255, 255, 0.8)",
      label: "Alt Başlık Rengi",
    },
    iconColor: {
      key: "multipleBonusDialogIconColor",
      cssVar: "--multiple-bonus-dialog-icon-color",
      default: "#1375E1",
      label: "Hediye İkonu Rengi",
    },
    closeIconColor: {
      key: "multipleBonusDialogCloseIconColor",
      cssVar: "--multiple-bonus-dialog-close-icon-color",
      default: "#FFFFFF",
      label: "Çarpı İkonu Rengi",
    },
    closeIconBgColor: {
      key: "multipleBonusDialogCloseIconBgColor",
      cssVar: "--multiple-bonus-dialog-close-icon-bg-color",
      default: "#0F212E",
      label: "Çarpı İkonu Arka Plan",
    },
    closeIconHoverBgColor: {
      key: "multipleBonusDialogCloseIconHoverBgColor",
      cssVar: "--multiple-bonus-dialog-close-icon-hover-bg-color",
      default: "#152B3C",
      label: "Çarpı İkonu Hover Arka Plan",
    },
    optionButtonBgColor: {
      key: "multipleBonusDialogOptionButtonBgColor",
      cssVar: "--multiple-bonus-dialog-option-button-bg-color",
      default: "#1375E1",
      label: "Seçenek Butonu Arka Plan",
    },
    optionButtonTextColor: {
      key: "multipleBonusDialogOptionButtonTextColor",
      cssVar: "--multiple-bonus-dialog-option-button-text-color",
      default: "#FFFFFF",
      label: "Seçenek Butonu Yazı Rengi",
    },
    optionButtonHoverBgColor: {
      key: "multipleBonusDialogOptionButtonHoverBgColor",
      cssVar: "--multiple-bonus-dialog-option-button-hover-bg-color",
      default: "#0F5FC4",
      label: "Seçenek Butonu Hover Arka Plan",
    },
    optionButtonGlowColor: {
      key: "multipleBonusDialogOptionButtonGlowColor",
      cssVar: "--multiple-bonus-dialog-option-button-glow-color",
      default: "rgba(19, 117, 225, 0.4)",
      label: "Seçenek Butonu Parıltı Rengi",
    },
    optionButtonHoverGlowColor: {
      key: "multipleBonusDialogOptionButtonHoverGlowColor",
      cssVar: "--multiple-bonus-dialog-option-button-hover-glow-color",
      default: "rgba(19, 117, 225, 0.5)",
      label: "Seçenek Butonu Hover Parıltı",
    },
    separatorTextColor: {
      key: "multipleBonusDialogSeparatorTextColor",
      cssVar: "--multiple-bonus-dialog-separator-text-color",
      default: "rgba(255, 255, 255, 0.6)",
      label: "Ayırıcı Yazı Rengi (veya)",
    },
    separatorLineColor: {
      key: "multipleBonusDialogSeparatorLineColor",
      cssVar: "--multiple-bonus-dialog-separator-line-color",
      default: "rgba(255, 255, 255, 0.2)",
      label: "Ayırıcı Çizgi Rengi",
    },
  },
  bonusCard: {
    brightness: {
      type: "range",
      key: "bonusCardBrightness",
      cssVar: "--bonus-card-brightness",
      default: "1",
      label: "Bonus Kart Parıltı",
    },
    color: {
      key: "bonusCardColor",
      cssVar: "--bonus-card-color",
      default: "#1375E1",
      label: "Bonus Kart Parıltı Rengi",
    },
  },
  bonusConfirmPopup: {
    overlayBgColor: {
      key: "bonusConfirmPopupOverlayBgColor",
      cssVar: "--bonus-confirm-popup-overlay-bg-color",
      default: "transparent",
      label: "Overlay Arka Plan Rengi",
    },
    popupBgColor: {
      key: "bonusConfirmPopupBgColor",
      cssVar: "--bonus-confirm-popup-bg-color",
      default: "#1e293b",
      label: "Popup Arka Plan Rengi",
    },
    popupBorderColor: {
      key: "bonusConfirmPopupBorderColor",
      cssVar: "--bonus-confirm-popup-border-color",
      default: "rgba(255, 255, 255, 0.1)",
      label: "Popup Kenarlık Rengi",
    },
    titleColor: {
      key: "bonusConfirmPopupTitleColor",
      cssVar: "--bonus-confirm-popup-title-color",
      default: "#f8fafc",
      label: "Başlık Rengi",
    },
    questionColor: {
      key: "bonusConfirmPopupQuestionColor",
      cssVar: "--bonus-confirm-popup-question-color",
      default: "#e2e8f0",
      label: "Soru Yazı Rengi",
    },
    imageBorderColor: {
      key: "bonusConfirmPopupImageBorderColor",
      cssVar: "--bonus-confirm-popup-image-border-color",
      default: "rgba(255, 255, 255, 0.15)",
      label: "Resim Kenarlık Rengi",
    },
    closeIconColor: {
      key: "bonusConfirmPopupCloseIconColor",
      cssVar: "--bonus-confirm-popup-close-icon-color",
      default: "#f8fafc",
      label: "Çarpı İkonu Rengi",
    },
    closeIconBgColor: {
      key: "bonusConfirmPopupCloseIconBgColor",
      cssVar: "--bonus-confirm-popup-close-icon-bg-color",
      default: "rgba(255, 255, 255, 0.1)",
      label: "Çarpı İkonu Arka Plan",
    },
    closeIconHoverBgColor: {
      key: "bonusConfirmPopupCloseIconHoverBgColor",
      cssVar: "--bonus-confirm-popup-close-icon-hover-bg-color",
      default: "rgba(255, 255, 255, 0.2)",
      label: "Çarpı İkonu Hover Arka Plan",
    },
    cancelButtonBgColor: {
      key: "bonusConfirmPopupCancelButtonBgColor",
      cssVar: "--bonus-confirm-popup-cancel-button-bg-color",
      default: "#334155",
      label: "Vazgeç Butonu Arka Plan",
    },
    cancelButtonTextColor: {
      key: "bonusConfirmPopupCancelButtonTextColor",
      cssVar: "--bonus-confirm-popup-cancel-button-text-color",
      default: "#f8fafc",
      label: "Vazgeç Butonu Yazı Rengi",
    },
    cancelButtonHoverBgColor: {
      key: "bonusConfirmPopupCancelButtonHoverBgColor",
      cssVar: "--bonus-confirm-popup-cancel-button-hover-bg-color",
      default: "#475569",
      label: "Vazgeç Butonu Hover Arka Plan",
    },
    cancelButtonGlowColor: {
      key: "bonusConfirmPopupCancelButtonGlowColor",
      cssVar: "--bonus-confirm-popup-cancel-button-glow-color",
      default: "rgba(51, 65, 85, 0.4)",
      label: "Vazgeç Butonu Parıltı Rengi",
    },
    confirmButtonBgColor: {
      key: "bonusConfirmPopupConfirmButtonBgColor",
      cssVar: "--bonus-confirm-popup-confirm-button-bg-color",
      default: "#3b82f6",
      label: "Talep Et Butonu Arka Plan",
    },
    confirmButtonTextColor: {
      key: "bonusConfirmPopupConfirmButtonTextColor",
      cssVar: "--bonus-confirm-popup-confirm-button-text-color",
      default: "#ffffff",
      label: "Talep Et Butonu Yazı Rengi",
    },
    confirmButtonHoverBgColor: {
      key: "bonusConfirmPopupConfirmButtonHoverBgColor",
      cssVar: "--bonus-confirm-popup-confirm-button-hover-bg-color",
      default: "#2563eb",
      label: "Talep Et Butonu Hover Arka Plan",
    },
    confirmButtonGlowColor: {
      key: "bonusConfirmPopupConfirmButtonGlowColor",
      cssVar: "--bonus-confirm-popup-confirm-button-glow-color",
      default: "rgba(59, 130, 246, 0.5)",
      label: "Talep Et Butonu Parıltı Rengi",
    },
    redirectLinkBgColor: {
      key: "bonusConfirmPopupRedirectLinkBgColor",
      cssVar: "--bonus-confirm-popup-redirect-link-bg-color",
      default: "#1e293b",
      label: "Yönlendirme Linki Arka Plan",
    },
    redirectLinkTextColor: {
      key: "bonusConfirmPopupRedirectLinkTextColor",
      cssVar: "--bonus-confirm-popup-redirect-link-text-color",
      default: "#e2e8f0",
      label: "Yönlendirme Linki Yazı Rengi",
    },
    redirectLinkLabelColor: {
      key: "bonusConfirmPopupRedirectLinkLabelColor",
      cssVar: "--bonus-confirm-popup-redirect-link-label-color",
      default: "#f8fafc",
      label: "Yönlendirme Linki Etiket Rengi",
    },
    redirectLinkBorderColor: {
      key: "bonusConfirmPopupRedirectLinkBorderColor",
      cssVar: "--bonus-confirm-popup-redirect-link-border-color",
      default: "rgba(255, 255, 255, 0.1)",
      label: "Yönlendirme Linki Kenarlık Rengi",
    },
    redirectLinkHoverColor: {
      key: "bonusConfirmPopupRedirectLinkHoverColor",
      cssVar: "--bonus-confirm-popup-redirect-link-hover-color",
      default: "#3b82f6",
      label: "Yönlendirme Linki Hover Rengi",
    },
  },
  loadingPage: {
    backgroundColor: {
      key: "loadingPageBgColor",
      cssVar: "--loading-page-bg-color",
      default: "linear-gradient(135deg, #0a1a28 0%, #0f212e 50%, #152b3c 100%)",
      label: "Arka Plan Rengi",
    },
    spinnerColor: {
      key: "loadingPageSpinnerColor",
      cssVar: "--loading-page-spinner-color",
      default: "#1475E1",
      label: "Loading Spinner Rengi",
    },
    textColor: {
      key: "loadingPageTextColor",
      cssVar: "--loading-page-text-color",
      default: "#666",
      label: "Yazı Rengi",
    },
    spinnerSize: {
      type: "range",
      key: "loadingPageSpinnerSize",
      cssVar: "--loading-page-spinner-size",
      default: "60",
      label: "Spinner Boyutu",
      min: 20,
      max: 120,
      step: 5,
      unit: "px",
    },
  },
};

// Tüm renk değerlerini düzleştir
const flattenThemeConfig = (config) => {
  const flattened = {};
  Object.keys(config).forEach((section) => {
    Object.keys(config[section]).forEach((property) => {
      const key = `${section}_${property}`;
      flattened[key] = config[section][property];
    });
  });
  return flattened;
};

const FLAT_CONFIG = flattenThemeConfig(THEME_CONFIG);

// Tema yönetimi hook'u
export const useThemeManager = () => {
  const [isLoadingFromApi, setIsLoadingFromApi] = useState(true);
  
  // Tüm tema değerlerini tek state'te tut (başlangıçta sadece default değerler)
  const [themeValues, setThemeValues] = useState(() => {
    const initialValues = {};
    Object.keys(FLAT_CONFIG).forEach((key) => {
      const configItem = FLAT_CONFIG[key];
      let value = configItem.default;
      
      // Eğer unit varsa ve default değer unit içermiyorsa, unit ekle
      if (configItem.unit && configItem.default && !String(configItem.default).includes(configItem.unit)) {
        value = `${configItem.default}${configItem.unit}`;
      }
      
      initialValues[key] = value;
    });
    return initialValues;
  });

  // CSS değişkenlerini güncelle
  const updateCSSVariable = useCallback((cssVar, value) => {
    const stringValue = String(value);
    if (stringValue === "0" || stringValue === "0px" || stringValue === "0%" || stringValue === "" || value === null || value === 0) {
      document.documentElement.style.removeProperty(cssVar);
    } else {
      document.documentElement.style.setProperty(cssVar, stringValue);
    }
  }, []);

  // localStorage'dan CSS'leri yükle (fallback)
  const loadFromLocalStorage = useCallback(() => {
    const values = {};
    Object.keys(FLAT_CONFIG).forEach((key) => {
      const configItem = FLAT_CONFIG[key];
      const savedValue = localStorage.getItem(configItem.key);
      let value = savedValue || configItem.default;
      
      if (configItem.unit && !savedValue && configItem.default && !String(configItem.default).includes(configItem.unit)) {
        value = `${configItem.default}${configItem.unit}`;
      }
      
      values[key] = value;
      updateCSSVariable(configItem.cssVar, value);
    });
    setThemeValues(values);
  }, [updateCSSVariable]);

  // API'den CSS'leri çek ve uygula (öncelikli)
  const loadCssFromApi = useCallback(async () => {
    try {
      if (!window.rh || !window.rh.cr) {
        loadFromLocalStorage();
        setIsLoadingFromApi(false);
        return;
      }

      const payload = JSON.stringify({
        process_id: "get-css",
        user_id: "",
      });

      const keys = await window.rh.cr(payload);
      
      const response = await fetch(
        `${config.apiBaseUrl}`,
        {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "hk": keys[0],
            "hh": keys[1]
          },
          body: payload,
        }
      );

      if (!response.ok) {
        loadFromLocalStorage();
        setIsLoadingFromApi(false);
        return;
      }

      const result = await response.json();
      
      let cssData = result;
      
      if (result.status && result.data) {
        cssData = result.data;
      } else if (result.status === false) {
        loadFromLocalStorage();
        setIsLoadingFromApi(false);
        return;
      }
      
      if (cssData && typeof cssData === 'object') {
        const newThemeValues = {};
        Object.keys(FLAT_CONFIG).forEach((key) => {
          const configItem = FLAT_CONFIG[key];
          const apiValue = cssData[configItem.cssVar];
          
          if (apiValue !== undefined && apiValue !== null && apiValue !== '') {
            // API'den gelen değeri kullan (öncelikli)
            newThemeValues[key] = apiValue;
            // localStorage'a da kaydet (cache olarak)
            localStorage.setItem(configItem.key, apiValue);
            updateCSSVariable(configItem.cssVar, apiValue);
          } else {
            // API'de yoksa localStorage veya default kullan
            const savedValue = localStorage.getItem(configItem.key);
            let value = savedValue || configItem.default;
            
            if (configItem.unit && !savedValue && configItem.default && !String(configItem.default).includes(configItem.unit)) {
              value = `${configItem.default}${configItem.unit}`;
            }
            
            newThemeValues[key] = value;
            updateCSSVariable(configItem.cssVar, value);
          }
        });
        
        setThemeValues(newThemeValues);
      } else {
        loadFromLocalStorage();
      }
    } catch (error) {
      loadFromLocalStorage();
    } finally {
      setIsLoadingFromApi(false);
    }
  }, [loadFromLocalStorage, updateCSSVariable]);

  // Sayfa yüklendiğinde API'den CSS'leri yükle
  useEffect(() => {
    loadCssFromApi();
  }, [loadCssFromApi]);

  // Local storage'ı güncelle (geçici cache olarak)
  const updateLocalStorage = useCallback((key, value) => {
    localStorage.setItem(key, value);
  }, []);

  // Tema değerini güncelle (sadece localStorage ve CSS değişkeni, API'ye kaydetmez)
  const updateThemeValue = useCallback(
    (key, value) => {
      const configItem = FLAT_CONFIG[key];
      if (!configItem) return;

      setThemeValues((prev) => ({ ...prev, [key]: value }));
      updateCSSVariable(configItem.cssVar, value);
      updateLocalStorage(configItem.key, value); // Geçici cache olarak
    },
    [updateCSSVariable, updateLocalStorage]
  );

  // Tüm tema ayarlarını sıfırla
  const resetToDefaults = useCallback(() => {
    Object.keys(FLAT_CONFIG).forEach((key) => {
      const config = FLAT_CONFIG[key];
      let defaultValue = config.default;
      
      // Eğer unit varsa ve default değer unit içermiyorsa, unit ekle
      if (config.unit && defaultValue && !String(defaultValue).includes(config.unit)) {
        defaultValue = `${defaultValue}${config.unit}`;
      }
      
      setThemeValues((prev) => ({ ...prev, [key]: defaultValue }));
      updateCSSVariable(config.cssVar, defaultValue);
      localStorage.removeItem(config.key);
    });
  }, [updateCSSVariable]);

  // ThemeValues değiştiğinde CSS değişkenlerini güncelle (API yüklemesi tamamlandıktan sonra)
  useEffect(() => {
    if (!isLoadingFromApi) {
      Object.keys(FLAT_CONFIG).forEach((key) => {
        const configItem = FLAT_CONFIG[key];
        let value = themeValues[key];
        
        if (configItem.unit && value === configItem.default && !value.includes(configItem.unit)) {
          value = `${value}${configItem.unit}`;
        }
        
        updateCSSVariable(configItem.cssVar, value);
      });
    }
  }, [themeValues, updateCSSVariable, isLoadingFromApi]);

  return {
    themeValues,
    themeConfig: THEME_CONFIG,
    flatConfig: FLAT_CONFIG,
    updateThemeValue,
    resetToDefaults,
  };
};
